import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";

const contactPersonApi = factory.get("contactPerson");

const initialState = {
  searchBody: {},
  contactPerson: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      name: "",
      mobile_1: "",
      mobile_2: "",
      job_title: "",
    },
  },
  contactPersons: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const contactPersonSlice = createSlice({
  name: "contactPerson",
  initialState,
  reducers: {
    setDialog: (state) => {
      state.contactPerson.dialog = !state.contactPerson.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.contactPersons.data = payload.data.data;
      state.contactPersons.total = payload.data.total;
    },
    setById: (state, { payload }) => {
      state.contactPerson.form.id = payload.id;
      state.contactPerson.form.name = payload.name;
      state.contactPerson.form.mobile_1 = payload.mobile_1;
      state.contactPerson.form.mobile_2 = payload.mobile_2 ?? "";
      state.contactPerson.form.job_title = payload.job_title ?? "";
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state) => {
      state.contactPerson.form = initialState.contactPerson.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
} = contactPersonSlice.actions;

export default contactPersonSlice.reducer;

// Thunks
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("contactPersons"));
    const res = await contactPersonApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("contactPersons"));
  } catch (err) {
    dispatch(setLoading("contactPersons"));
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const deleteById = (id, _SearchBody) => async (dispatch) => {
  try {
    await contactPersonApi.delete(id);
    dispatch(
      showNotification({
        message: "تم الحذف بنجاح",
        type: "success",
      }),
    );
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("contactPerson"));
    const res = await contactPersonApi.getById(id);
    dispatch(setById(res.data.data[0]));
    dispatch(setDialog());
    dispatch(setLoading("contactPerson"));
  } catch (err) {
    dispatch(setLoading("contactPerson"));
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const create = (data, searchBody) => async (dispatch) => {
  try {
    dispatch(setLoading("contactPerson"));
    await contactPersonApi.create(data);
    dispatch(
      showNotification({
        message: "تمت الإضافة بنجاح",
        type: "success",
      }),
    );
    dispatch(setLoading("contactPerson"));
    dispatch(setDialog());
    dispatch(getAll(searchBody));
  } catch (err) {
    dispatch(setLoading("contactPerson"));
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const update = (id, data, _SearchBody) => async (dispatch) => {
  try {
    dispatch(setLoading("contactPerson"));
    await contactPersonApi.update(id, data);
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      }),
    );
    dispatch(setLoading("contactPerson"));
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(setLoading("contactPerson"));
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "حدث خطأ",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

export const ContactPerson = {
  getAll,
  deleteById,
  getById,
  create,
  update,
};
